import { useMutation } from '@tanstack/react-query'

import type {
  InitiateInstallmentPaymentRequest,
  InitiateInstallmentPaymentResponse,
} from '../../types/deposit.js'

import { apiClient } from '../../lib/client.js'

export const useInitiateInstallmentPaymentMutation = () => {
  return useMutation({
    mutationFn: async (data: InitiateInstallmentPaymentRequest) => {
      const response = await apiClient.client.post<InitiateInstallmentPaymentResponse>(
        '/payment/initiate-installments',
        data
      )
      return response.data
    },
  })
}
